import React from 'react';
import { Bot, Users, GitMerge, Zap } from 'lucide-react';
export const CoreOffering = () => {
  return <section id="features" className="py-20 bg-black relative overflow-hidden" data-id="element-106">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_right,_rgba(255,255,255,0.03)_0,_transparent_70%)]" data-id="element-107"></div>
      <div className="container mx-auto px-4 relative z-10" data-id="element-108">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-109">
          <h2 className="font-['Playfair_Display'] text-3xl md:text-4xl font-light mb-6" data-id="element-110">
            Core <span className="text-white" data-id="element-111">Offering</span>
          </h2>
          <p className="font-['Space_Grotesk'] text-zinc-300 font-light" data-id="element-112">
            Our core package covers the main channels where most intake
            communications happen: phone calls, text messages and engagement
            with website visitors.
          </p>
        </div>
        <div className="grid md:grid-cols-2 gap-8" data-id="element-113">
          <div className="bg-gradient-to-br from-zinc-900/50 to-black/50 p-8 rounded-sm border border-white/10 backdrop-blur-sm" data-id="element-114">
            <Bot size={32} className="text-white mb-6" data-id="element-115" />
            <h3 className="font-['Playfair_Display'] text-xl mb-4" data-id="element-116">
              Custom AI Intake Agent
            </h3>
            <p className="font-['Space_Grotesk'] text-zinc-300 font-light" data-id="element-117">
              Trained on legal intake workflows by LexSquire, the AI acts as the
              first responder for new inquiries and hands off seamlessly to a
              human when needed.
            </p>
          </div>
          <div className="bg-gradient-to-br from-zinc-900/50 to-black/50 p-8 rounded-sm border border-white/10 backdrop-blur-sm" data-id="element-118">
            <GitMerge size={32} className="text-white mb-6" data-id="element-119" />
            <h3 className="font-['Playfair_Display'] text-xl mb-4" data-id="element-120">
              Flexible Routing
            </h3>
            <p className="font-['Space_Grotesk'] text-zinc-300 font-light" data-id="element-121">
              Firms can choose AI-first intake, or human-first intake with AI
              covering overflow, after-hours, weekends, and foreign-language
              conversations.
            </p>
          </div>
          <div className="bg-gradient-to-br from-zinc-900/50 to-black/50 p-8 rounded-sm border border-white/10 backdrop-blur-sm" data-id="element-122">
            <Users size={32} className="text-white mb-6" data-id="element-123" />
            <h3 className="font-['Playfair_Display'] text-xl mb-4" data-id="element-124">
              Human Expertise
            </h3>
            <p className="font-['Space_Grotesk'] text-zinc-300 font-light" data-id="element-125">
              Our team of intake specialists brings years of legal call center
              experience, ensuring every client interaction is handled with care
              and expertise.
            </p>
          </div>
          <div className="bg-gradient-to-br from-zinc-900/50 to-black/50 p-8 rounded-sm border border-white/10 backdrop-blur-sm" data-id="element-126">
            <Zap size={32} className="text-white mb-6" data-id="element-127" />
            <h3 className="font-['Playfair_Display'] text-xl mb-4" data-id="element-128">
              Premium Optimization
            </h3>
            <p className="font-['Space_Grotesk'] text-zinc-300 font-light" data-id="element-129">
              A service-based add-on lets firms split-test AI vs. human intake
              across channels, using outcome analytics to continuously optimize
              results.
            </p>
          </div>
        </div>
        <div className="mt-16 text-center" data-id="element-130">
          <a href="/features" className="bg-white text-black px-6 py-3 rounded-sm hover:bg-zinc-200 transition-colors inline-block" data-id="element-131">
            Explore All Features
          </a>
        </div>
      </div>
    </section>;
};